export const GET_FORGOT_PASSWORD = "GET_FORGOT_PASSWORD";
export const GET_FORGOT_PASSWORD_SUCCESS = "GET_FORGOT_PASSWORD_SUCCESS";
export const GET_FORGOT_PASSWORD_ERROR = "GET_FORGOT_PASSWORD_ERROR";
